import { useEffect } from 'react';

interface ScriptOption {
  src: string;
  onLoad?: Function;
  enabled?: boolean;
}

function useScript({ src, onLoad, enabled = true }:ScriptOption) {
    useEffect(() => {
        if (enabled) {
            const exists = document.querySelector(`script[src="${src}"]`);
            if (exists) {
                return;
            }
            const script = document.createElement('script');
            if (onLoad) {
                script.onload = () => onLoad();
            }
            document.head.appendChild(script);
            script.src = src;
        }
    }, [src, onLoad, enabled]);
}

export default useScript;
